const message = {
  news: "News",
  btnShowMore: "Show More",
  featuredArticles: "Featured <span class='text-green'> articles</span> ",
  lastNews: "Last News",
  next: "Next >",
  previous: "< Previous",
};
export default message;
